export default __webpack_public_path__ + "static/media/wm4.d0bcfa5f.jpg";